import { BALANCE, CREDIT, DEPOSIT, DEPOSIT1, DEPOSIT2 } from '../../consts/paymentTypes';

export const getPaidAmountByType = (payments, type) =>
    (payments || [])
        .filter((payment) => payment.type === type)
        .reduce((acc, payment) => acc + Number(payment.amount || 0), 0);

export const getOwedForType = (po, type, excludePaymentId) => {
    const allPayments = po.payments || [];
    const payments = excludePaymentId
        ? allPayments.filter((payment) => payment.id !== excludePaymentId)
        : allPayments;
    const milestones = po.paymentBarMilestones || {};
    const remaining = (milestone, paid) => Math.max(Number(milestone || 0) - paid, 0);
    if (type === DEPOSIT || type === DEPOSIT1 || type === DEPOSIT2) {
        const depositPaid =
            getPaidAmountByType(payments, DEPOSIT) +
            getPaidAmountByType(payments, DEPOSIT1) +
            getPaidAmountByType(payments, DEPOSIT2);
        return remaining(milestones[DEPOSIT], depositPaid);
    }
    if (type === BALANCE) return remaining(milestones[BALANCE], getPaidAmountByType(payments, BALANCE));
    if (type === CREDIT) return remaining(milestones[CREDIT], getPaidAmountByType(payments, CREDIT));
    const excludedAmount = excludePaymentId
        ? allPayments
            .filter((payment) => payment.id === excludePaymentId)
            .reduce((acc, payment) => acc + Number(payment.amount || 0), 0)
        : 0;
    return Math.max(Number(po.amountOwed || 0) + excludedAmount, 0);
};

export const getExistingPaymentTypes = (payments) => new Set((payments || []).map((payment) => payment.type));
